import useMedia from './useMedia';

export function useIsMobile() {
	return useMedia('(max-width: 640px)');
}
